var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGearLavender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6692 87.5174C73.1041 87.5174 88.8592 71.7623 88.8592 52.3274C88.8592 32.8925 73.1041 17.1374 53.6692 17.1374C34.2343 17.1374 18.4792 32.8925 18.4792 52.3274C18.4792 71.7623 34.2343 87.5174 53.6692 87.5174Z",
    fill: "#B48DAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6764 30.6964L9.31696 21.3794L-1.81934e-05 41.7388L20.3594 51.0558L29.6764 30.6964Z",
    fill: "#B48DAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3996 59.8248L2.75842 73.6125L16.5462 91.2537L34.1873 77.4659L20.3996 59.8248Z",
    fill: "#B48DAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0064 83.8894L44.5292 106.228L66.8674 104.705L65.3445 82.3666L43.0064 83.8894Z",
    fill: "#B48DAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4058 77.6378L94.7961 88.8328L105.991 69.4425L86.6008 58.2475L75.4058 77.6378Z",
    fill: "#B48DAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6593 23.861L60.9975 22.3382L59.4746 -8.42435e-07L37.1365 1.52286L38.6593 23.861Z",
    fill: "#B48DAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.366 43.4049L102.558 30.3521L89.5048 12.1604L71.3132 25.2132L84.366 43.4049Z",
    fill: "#B48DAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2392 64.6874C61.0765 64.6874 66.6192 59.1447 66.6192 52.3074C66.6192 45.4701 61.0765 39.9274 54.2392 39.9274C47.4019 39.9274 41.8592 45.4701 41.8592 52.3074C41.8592 59.1447 47.4019 64.6874 54.2392 64.6874Z",
    fill: "#2E1926"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearLavender);
export default __webpack_public_path__ + "static/media/gear_lavender.a194f0ccd9201dc9a12a32d387ac029d.svg";
export { ForwardRef as ReactComponent };